const searchPlaceHolder: any = {
  users: "Search",
  roles: "Search",
  "fee-structure": "Search",
  "student-list": "Search",
  "payments-listing": "Search",
};
export default searchPlaceHolder;
